import {
  StatusIndicator,
  StatusIndicatorProps,
} from '@amzn/awsui-components-console';
import { ReactElement } from 'react';

const statusMap: Record<string, StatusIndicatorProps> = {
  DONE: {
    type: 'success',
    children: 'Build Succeeded',
  },
  SUBMITTING: {
    type: 'loading',
    children: 'Submitting',
  },
  WAITING: {
    type: 'loading',
    children: 'Waiting',
  },
  IN_PROGRESS: {
    type: 'in-progress',
    children: 'In Progress',
  },
  SUBMIT_FAILED: {
    type: 'error',
    children: 'Submit Failed',
  },
  FAILED: {
    type: 'error',
    children: 'Build Failed',
  },
  CANCELED: {
    type: 'error',
    children: 'Build Canceled',
  },
  SUBMIT_SKIPPED: {
    type: 'info',
    children: 'Build Skipped',
  },
} as const;

function getIndicator(status: string): StatusIndicatorProps {
  return (
    statusMap[status] ?? {
      type: 'not-started',
      children: status,
    }
  );
}

export const BuildStatusIndicator = ({
  status,
}: {
  status: string;
}): ReactElement => <StatusIndicator {...getIndicator(status)} />;
